export enum SiteType {
  rontoSite = 1,
  controllerSite = 2,
  rontoServiceSite = 3,
}
export interface Site {
  readonly id: number;
  name: string;
  description: string;
  ownerId: number;
  type: number;
  userIds: string;
  deviceId: string;
  createAt: number;
  updateAt: number;
}
